import {customerInfoSchema} from './customer-info.model';
import {z} from 'zod';
import {legislationSchema} from './legislation.model';
import {costGroupSchema} from './cost-group.model';
import {buildingInfoSchema} from './building-info.model';
import {zDateTime, zNumberToString} from '@brunata-angular/util';
import {billingAddressInfoSchema} from './billing-address-info.model';
import {oldWebbillCostSpecificationsSchema} from './webbill-cost-specification.model';

export const costDocSchema = z.object({
    webBillCustomerInfo: customerInfoSchema,
    accountHeading: z.string().nullable(),
    accountPeriodId: zNumberToString,
    periodStartDate: zDateTime,
    onlineReportingEmail: z.string().nullable(),
    costGroups: z.array(costGroupSchema),
    requestedDeliveryDate: z.string().nullable(),
    legislations: z.array(legislationSchema),
    billMessageOutstanding: z.string().nullable(),
    billMessageRefund: z.string().nullable(),
    newPeriodStartDate: zDateTime.nullable(),
    contactPerson: z.string().nullable(),
    newPeriodEndDate: zDateTime.nullable(),
    contactEmail: z.string().nullable(),
    costsStartDate: zDateTime,
    contactPhoneNo: z.string().nullable(),
    periodEndDate: zDateTime,
    accountEmail: z.string().nullable(),
    costReceivedDate: zDateTime.nullable(),
    webBillLegislations: z.array(legislationSchema),
    costsAcceptedDate: zDateTime.nullable(),
    noteToBrunata: z.string().nullable(),
    costsAcceptedBy: z.string().nullable(),
    billMessageFromCustomer: z.string().nullable(),
    webBillBuildingInfo: buildingInfoSchema,
    requestResidentList: z.boolean(),
    residentListAccepted: z.boolean(),
    customerName: z.string().nullable(),
    customerAddress1: z.string().nullable(),
    customerAddress2: z.string().nullable(),
    customerCity: z.string().nullable(),
    customerPostalCode: z.string().nullable(),
    customerCountryCode: z.string().nullable(),
    billingAddressName: z.string().nullable(),
    billingAddress1: z.string().nullable(),
    billingAddress2: z.string().nullable(),
    billingAddressCity: z.string().nullable(),
    billingAddressPostalCode: z.string().nullable(),
    billingCountryCode: z.string().nullable(),
    webBillBillingAddressInfo: billingAddressInfoSchema,
    webbillAccountEmail: z.string().nullable(),
    oldCostSpecifications: z.array(oldWebbillCostSpecificationsSchema),
    accountType: z.string().nullable(),
});

export type CostDoc = z.infer<typeof costDocSchema>;
